import React, { useState, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { usagesColumns } from "./config";
import { useGetUsagesQuery } from "../../services/inventoryService";
import { dataGridStyles, localeText } from "../../utils/dataGridConfig";
import ErrorComponent from "../../components/ErrorComponent";

const Usages = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  // Fetch data with pagination and search term
  const { data: usages, error, isLoading, refetch } = useGetUsagesQuery({
    offset: paginationModel.page * paginationModel.pageSize,
    limit: paginationModel.pageSize,
  });

  // Re-fetch data when paginationModel or searchTerm changes
  useEffect(() => {
    refetch();
  }, [paginationModel, refetch]);

  const handleView = async (id) => {
    navigate(`${window.location.pathname}/view/${id}`);
  };

  const columns = usagesColumns(handleView, colors);

  if (error) {
    return <ErrorComponent />;
  }

  return (
    <Box m="20px">
      <Header title="Salidas" subtitle="Lista de Salidas" showCreateButton={true} />

      {/* Filter Section */}
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      >
      </Box>

      <Box sx={dataGridStyles(colors)} height="75vh">
        <DataGrid
          columns={columns}
          rows={usages?.records || []}
          rowCount={usages?.count || 0}
          loading={isLoading}
          pagination
          paginationModel={paginationModel}
          rowsPerPageOptions={[10, 20, 50]}
          pageSizeOptions={[10, 20, 50]}
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) => {
            setPaginationModel(newPaginationModel);
          }}
          loadingText="Cargando..."
          localeText={localeText}
          disableRowSelectionOnClick
          disableColumnMenu
          disableColumnSorting
        />
      </Box>
    </Box>
  );
};

export default Usages;